module.exports = __webpack_public_path__ + "img/10.R.371b6dab.jpg";